import React from "react";

/* Avatar — initials, image, or asset coin mark. Circular. */
const SIZES = { xs: 24, sm: 32, md: 40, lg: 48 };
const FONT = { xs: 10, sm: 12, md: 14, lg: 16 };

/* Deterministic soft tint from a string. */
const TINTS = [
  ["#E8F1FE", "#1A5FC4"],
  ["#E6FBEF", "#1B8553"],
  ["#FFF4E5", "#B45309"],
  ["#EFEAFE", "#5B43C4"],
  ["#FDEAF0", "#B23A6A"],
  ["#E7F6F6", "#0E7E7E"],
];
function tintFor(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return TINTS[h % TINTS.length];
}
function initials(name = "") {
  const p = name.trim().split(/\s+/);
  return ((p[0]?.[0] || "") + (p[1]?.[0] || "")).toUpperCase() || "?";
}

const DEFAULT_TINT = ["var(--avatar-bg)", "var(--avatar-fg)"];

export function Avatar({ name = "", initials: initialsOverride, src, size = "md", square = false, variant, style, ...rest }) {
  const dim = SIZES[size] || SIZES.md;
  const [bg, fg] = variant === "default" ? DEFAULT_TINT : tintFor(name);
  const label = initialsOverride ?? initials(name);
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: dim,
        height: dim,
        flex: "none",
        borderRadius: square ? "var(--radius-sm)" : "50%",
        background: src ? "var(--grey-bg)" : bg,
        color: fg,
        fontFamily: "var(--font-sans)",
        fontWeight: 700,
        fontSize: FONT[size] || 14,
        letterSpacing: "0.02em",
        overflow: "hidden",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.04)",
        ...style,
      }}
      {...rest}
    >
      {src ? (
        <img src={src} alt={name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        label
      )}
    </span>
  );
}

export default Avatar;
